import { render, staticRenderFns } from "./LinkDialogOpenerForPaymentAndInvoicingReport.vue?vue&type=template&id=28604966&scoped=true&"
import script from "./LinkDialogOpenerForPaymentAndInvoicingReport.vue?vue&type=script&lang=js&"
export * from "./LinkDialogOpenerForPaymentAndInvoicingReport.vue?vue&type=script&lang=js&"
import style0 from "./LinkDialogOpenerForPaymentAndInvoicingReport.vue?vue&type=style&index=0&id=28604966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28604966",
  null
  
)

export default component.exports